var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all"},[_c('iframe',{ref:"iframe",staticClass:"full_screen",style:(_vm.newStyle),attrs:{"id":"full_screen","src":_vm.href,"frameborder":"0","height":"100%","width":"100%","scrolling":"no"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }